'use client';

import { Button } from '@shared/components/shadcn';
import { Verified } from '@shared/icons/system';
import { useTranslations } from 'next-intl';
import { useFormContext } from 'react-hook-form';
import { useMultistepForm } from '../../../../../form-controls/MultistepForm/hooks/useMultistepForm';

const ConfirmationStep = () => {
  const t = useTranslations('my_account.safer_gambling.reality_check');
  const { watch } = useFormContext();
  const { goToNextStep } = useMultistepForm();
  const interval = watch('interval') || 'NO_SET';

  const handleDone = async () => {
    await goToNextStep(); // This will trigger onComplete in the MultistepForm which closes the sheet
  };

  return (
    <div
      className="flex flex-col gap-8 px-6 py-0"
      data-track-container="Reality Check Confirmed"
      data-track-value={t(`intervals.${interval}`)}
      data-testid="reality-check-confirmation-step"
    >
      {/* Illustrative Message Section */}
      <div className="flex flex-col gap-4 items-start justify-start w-full mt-5">
        <Verified size="extra-extra-large" data-testid="verified-icon" />
        <h4 className="w-full">
          {t('steps.confirmation.title', {
            interval: t(`intervals.${interval}`),
          })}
        </h4>
      </div>

      <div className="mt-auto" data-track-container="Actions">
        <Button className="w-full" onClick={handleDone} data-testid="continue-button" data-track-name="Done">
          {t('steps.confirmation.done')}
        </Button>
      </div>
    </div>
  );
};

export { ConfirmationStep };
